import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest*"
import connect from "./connect"

type FavouritesBadgeProps = {
    iconUrl: string
    altText: string
    hideBadge: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

const FavouritesBadge = memo(({iconUrl, altText, hideBadge, templating}: FavouritesBadgeProps) => {
    const TemplatedBadge = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <TemplatedBadge hideBadge={hideBadge}>
                <img src={iconUrl} alt={altText} aria-hidden />
            </TemplatedBadge>
        </Suspense>
    )
})
FavouritesBadge.displayName = "FavouritesBadge"

export default connect(FavouritesBadge)
